'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import CartSmall from './components/CartSmall.vue';
import CartSmallRow from './components/CartSmallRow.vue';

var _class = function _class() {
    _classCallCheck(this, _class);

    // Register component globaly
    Vue.component('cart-small', CartSmall);
    Vue.component('cart-small-row', CartSmallRow);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/cart-small/index.js
// module id = null
// module chunks = 